//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:{
        headImg:String,
        rating:Number
    },
    data(){
        return{
            stars: [1,2,3,4,5],
            score: 0,
            show_submit: false,
            show_edit: false
        }
    },
    computed: {
        rate_text () {
            const index = this.score - 1
            if (index > -1) {
                return [
                    '不满意',
                    '一般',
                    '满意',
                    '比较满意',
                    '非常满意!'
                ][index]
            }
            return ''
        },
        can_submit(){
            return this.score > 0
        }
    },
    watch: {
        rating: {
            handler(rating){
                if (rating > 0) {
                    this.show_submit = false
                    this.show_edit = true
                }else{
                    this.show_submit = true
                }
                if (rating != this.score) {
                    this.score = rating
                }
            },
            immediate:true
        }
    },
    methods:{
        hide () {
            this.$emit('hide')
            this.show_submit = false
            this.show_edit = this.rating > 0
            this.score = this.rating
        },
        edit () {
            this.show_edit = false
            this.show_submit = true
            this.score = 0
        },
        select (i) {
            if (!this.show_edit) {
                this.score = i + 1
                this.show_submit = true
            }
        },
        submit () {
            if (this.score) {
                this.$emit('submit', this.score)
            }
        }
    }
}
